import { HTTP_STATUS_CODES, QUOTATION_CODE_STATUS } from "app/constants";

export const NO_SEARCH_RESULT_ERROR_TYPE = "no_result";

export const NO_SEARCH_RESULT_ERROR_CATEGORY = {
	LISTING: "listing",
	INVENTORY: "inventory",
	NOT_FOUND: "404",
};

const INVENTORY_STATUSES = [QUOTATION_CODE_STATUS.FULL_FLIGHT, QUOTATION_CODE_STATUS.FULL_PROPERTY];

export const getNoSearchResultErrorCategory = status => {
	if (INVENTORY_STATUSES.includes(status)) {
		return NO_SEARCH_RESULT_ERROR_CATEGORY.INVENTORY;
	}

	if (status === QUOTATION_CODE_STATUS.NOT_FOUND) {
		return NO_SEARCH_RESULT_ERROR_CATEGORY.NOT_FOUND;
	}

	return NO_SEARCH_RESULT_ERROR_CATEGORY.LISTING;
};

// An aborted request or a network timeout resolves without HTTP status: it is not an empty result
export const isNoSearchResult = ({ httpStatusCode, productCount }) =>
	httpStatusCode === HTTP_STATUS_CODES.OK && productCount === 0;
